import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { toast } from 'react-toastify';

const useErrorToast = (message: string, id?: string) => {
  const errorToastId = id || 'errorToast';

  if (toast.isActive(errorToastId)) {
    toast.dismiss(errorToastId);
  }

  toast.error(message, {
    icon: false,
    theme: 'colored',
    toastId: errorToastId,
    hideProgressBar: true,
    autoClose: 4000,
    closeButton: (
      <React.Fragment>
        <button
          id="error_toast__close"
          className="rounded-md text-red-500 self-start"
          onClick={() => toast.dismiss(errorToastId)}
          aria-label="close-modal"
          type="button"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </React.Fragment>
    ),
  });
};

const useSuccessToast = (message: string) => {
  const successToastId = 'successToast';

  if (toast.isActive(successToastId)) {
    toast.dismiss(successToastId);
  }

  toast.success(message, {
    icon: false,
    theme: 'colored',
    toastId: successToastId,
    hideProgressBar: true,
    autoClose: 4000,
    closeButton: (
      <React.Fragment>
        <button
          id="success_toast__close"
          className="rounded-md text-green-500 self-start"
          onClick={() => toast.dismiss(successToastId)}
          aria-label="close-modal"
          type="button"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </React.Fragment>
    ),
  });
};

export { useErrorToast, useSuccessToast };
